var map = {
	"./IMG_0098.jpeg": 597,
	"./IMG_2326.c9aace52.jpg": 5758,
	"./IMG_4261.jpeg": 1513,
	"./bmg6.39e20bbd.JPG": 656,
	"./bmg7.5c8e7c32.JPG": 7172,
	"./swim3.4eada22c.png": 2622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8678;